import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DevicesService } from '../../services/devices.service';
import { MovementsService } from '../../services/movements.service';
import { LoginUserModel } from '../../models/loginUserModel';
import { Driver } from '../../models/Driver';
import { Title } from '@angular/platform-browser';
import { ThemeService } from '../../theme.service';
import { ToastService } from '../../services/toast.service';
import { LoaderComponent } from '../../utils/loader/loader.component';
import { AvatarComponent } from '../../utils/avatar/avatar.component';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'app-driver-assignment',
  imports: [
    CommonModule, FormsModule, LoaderComponent, AvatarComponent,
    TableModule, ButtonModule, InputTextModule,
    IconFieldModule, InputIconModule, ToggleSwitchModule, TooltipModule
  ],
  templateUrl: './driver-assignment.component.html',
  styleUrl: './driver-assignment.component.scss'
})
export class DriverAssignmentComponent {
  isLoader = false;
  data!: LoginUserModel;
  tableData: any[] = [];
  filteredTable: any[] = [];
  drivers: any[] = [];
  _drivers: any[] = [];
  isChoice = false;
  allGenQR = false;
  searchText = '';
  isChecked = false;
  dataResult: any[] = [];
  selectedDevice: any = null;

  get isAdmin() { return this.data.UserType === 'Administrator' || this.data.UserType === 'Modify'; }
  get userName() { return this.data.User_id === 0 ? 'Administrador de la cuenta' : this.data.Name; }
  get hasAssignedDrivers() { return this.drivers.some(d => d.type === 1 || d.type === 2); }

  constructor(
    private devicesSrv: DevicesService,
    private movSrv: MovementsService,
    private titleService: Title,
    private themeService: ThemeService,
    private toastSrv: ToastService
  ) {
    this.titleService.setTitle('Movimiento - Asignación de Conductores');
    this.themeService.setTitle('Asignación de Conductores');
    this.data = JSON.parse(localStorage.getItem('data')!);
  }

  ngOnInit() { this.loadDevices(); }

  loadDevices() {
    this.isLoader = true;
    this.devicesSrv.loadDevices(this.data.Client_number, this.data.User_id, '', this.isAdmin).subscribe({
      next: (resp: any) => {
        this.tableData = resp.filter((i: any) => i.isMaster !== 1 && i.deviceType !== 'M' && !i.description?.toUpperCase().includes('MAESTRA'));
        this.filteredTable = this.tableData;
        this.isLoader = false;
      },
      error: (err: any) => { this.isLoader = false; this.toastSrv.add({ type: 'error', message: err.error?.error || 'Error al cargar dispositivos' }); }
    });
  }

  searchByText(event: any) {
    const q = event.target.value.toLowerCase();
    this.filteredTable = this.tableData.filter(i =>
      (i.vehicleFullNumber || '').toLowerCase().includes(q) ||
      (i.description || '').toLowerCase().includes(q) ||
      (i.nameUser || '').toLowerCase().includes(q)
    );
  }

  searchByDrivers(event: any) {
    const q = event.target.value.toLowerCase();
    this.drivers = this._drivers.filter(i => (i.name || '').toLowerCase().includes(q));
  }

  selectDevice(device: any) {
    this.selectedDevice = device;
    this.searchText = '';
    this.isLoader = true;
    this.devicesSrv.getDrivers(this.data.Client_number, false).subscribe({
      next: (resp: any) => {
        if (resp.length > 0) {
          const mapped = resp.map((i: any) => ({ ...i, type: 0, is_qr_enabled: false, card_id: device.card_id, phone_number: (i.phone_number || '').replace(/\s/g, '') }));
          this.loadAssigned(device.card_id, this.data.Client_id, mapped);
        } else {
          this.isLoader = false;
          this.toastSrv.add({ type: 'info', message: 'Esta cuenta no tiene conductores dados de alta' });
        }
      },
      error: () => { this.isLoader = false; this.toastSrv.add({ type: 'error', message: 'Error al obtener conductores' }); }
    });
    this.isChoice = true;
  }

  private loadAssigned(cardId: number, clientId: number, drivers: any[]) {
    this.movSrv.getDriverTable(cardId, clientId).subscribe({
      next: (resp: any) => {
        if (resp.message === '') {
          drivers.forEach(d => {
            const idx = resp.response.items.findIndex((e: any) => e.driver_id === d.driver_id);
            if (idx > -1) { d.type = 1; d.is_qr_enabled = resp.response.items[idx].is_qr_enabled; }
          });
        }
        this.drivers = drivers;
        this._drivers = [...drivers];
        this.isLoader = false;
      },
      error: () => { this.isLoader = false; this.toastSrv.add({ type: 'error', message: 'Error al cargar asignaciones' }); }
    });
  }

  select(driver: any) {
    if (!this.isAdmin) return;
    const map: any = { 0: 2, 1: 4, 2: 0, 4: 1 };
    driver.type = map[driver.type] ?? driver.type;
    this.updateResult();
  }

  selectAll() {
    if (!this.isAdmin) return;
    this.isChecked = !this.isChecked;
    this.drivers.forEach(d => {
      if (this.isChecked && d.type === 0) d.type = 2;
      else if (this.isChecked && d.type === 4) d.type = 1;
      else if (!this.isChecked && d.type === 2) d.type = 0;
      else if (!this.isChecked && d.type === 1) d.type = 4;
    });
    this.updateResult();
  }

  private updateResult() {
    this.dataResult = this.drivers.filter(d => d.type === 2 || d.type === 4);
  }

  changeQR(event: boolean, driver: any) {
    driver.is_qr_enabled = event;
    if (driver.type === 1) this.updateDriverQR(driver);
  }

  toggleQR(driver: any) {
    driver.is_qr_enabled = !driver.is_qr_enabled;
    if (driver.type === 1) this.updateDriverQR(driver);
  }

  changeAllQR(event: boolean) {
    this.allGenQR = event;
    this.drivers.forEach(d => {
      if (d.type === 1 || d.type === 2) {
        if (event !== d.is_qr_enabled) { d.is_qr_enabled = event; if (d.type === 1) this.updateDriverQR(d); }
      }
    });
  }

  private updateDriverQR(driver: any) {
    driver.user_name = this.userName;
    this.devicesSrv.updateDriverQR(driver).subscribe({
      next: (resp: any) => { if (!resp.response) this.toastSrv.add({ type: 'error', message: resp.message }); },
      error: (err: any) => { this.toastSrv.add({ type: 'error', message: err.error?.error || 'Error' }); }
    });
  }

  save() {
    this.isLoader = true;
    const toSave = this.dataResult.filter(d => d.type === 2).map(d => ({ ...d, user_name: this.userName }));
    const toDelete = this.dataResult.filter(d => d.type === 4).map(d => ({ ...d, user_name: this.userName }));

    if (toSave.length > 0) {
      this.movSrv.saveDriver(toSave).subscribe({
        next: () => { this.drivers.forEach(d => { if (d.type === 2) d.type = 1; }); this.toastSrv.add({ type: 'success', message: 'Conductores asignados' }); this.dataResult = []; this.isLoader = false; },
        error: (err: any) => { this.isLoader = false; this.toastSrv.add({ type: 'error', message: err.error?.error || 'Error al asignar' }); }
      });
    }
    if (toDelete.length > 0) {
      this.movSrv.deleteDriver(toDelete).subscribe({
        next: () => { this.drivers.forEach(d => { if (d.type === 4) d.type = 0; }); this.toastSrv.add({ type: 'success', message: 'Conductores desasignados' }); this.dataResult = []; this.isLoader = false; },
        error: (err: any) => { this.isLoader = false; this.toastSrv.add({ type: 'error', message: err.error?.error || 'Error al desasignar' }); }
      });
    }
    if (toSave.length === 0 && toDelete.length === 0) this.isLoader = false;
  }

  cancel() {
    this.drivers.forEach(d => { if (d.type === 4) d.type = 1; else if (d.type === 2) d.type = 0; });
    this.dataResult = [];
    this.isChecked = false;
  }

  back() {
    this.dataResult = [];
    this.isChoice = false;
    this.selectedDevice = null;
    this.searchText = '';
    this.loadDevices();
  }

  onSwitchClick(event: Event) { event.stopPropagation(); }
}
